{
"authority": "https://si-agroid-identityserver.segestest.dk",
"clientId": "urn:xreg-devtest",
"redirectUri": "https://devtest-xreg.segestest.dk",
"scopes": ["devtest.xreg_api.client"],
"protectedResources": [
{
"resourceUri": "https://devtest-xreg-api.segestest.dk",
"scopes": ["devtest.xreg_api.client"]
}
]
}
